import React, { useRef } from 'react';
import { connect } from 'react-redux';

import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { IconWrapper, PanelRightBlock, PanelRow } from 'apps/auth/components/common/Panel/styles';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import BasePage from 'apps/auth/components/utils/BasePage';
import Spinner from 'apps/auth/components/utils/Spinner/Spinner';
import { AUTH_PROFILE, AUTH_PROFILE_LIMIT_INFO } from 'apps/auth/constants/UrlConstants';

const ProfileLimitsPage = (props) => {
    const popupRef = useRef(null);
    const profileForm = props.profileForm;

    const limit = (limit) => (
        <Row indent="adaptive-24-32">
            <Panel type="link" href={`${AUTH_PROFILE_LIMIT_INFO}/${limit.currencyId}`} isBordered hasBorderRadius>
                <PanelRow>
                    <PanelRow alignStart>
                        <IconWrapper>
                            <Icon name={`currency-${limit.currencyCode.toLowerCase()}`} color="primary" />
                        </IconWrapper>
                        <Text>{props.pageMessages['profileLimit_' + limit.currencyId]}</Text>
                    </PanelRow>
                    {limit.amlCurrencies?.length > 1 && (
                        <PanelRightBlock flex>
                            <Text>{props.profileBasicAmlDetails}</Text>
                            <Row
                                flex
                                onClick={(e) => {
                                    e.preventDefault();
                                    popupRef?.current?.open(
                                        <SimplePopup popupRef={popupRef} text={props.profileAmlCurrency}>
                                            <PopupButton text={props.profileCloseTitle} iconName="check" onClick={() => popupRef?.current?.close()} />
                                        </SimplePopup>,
                                    );
                                }}
                            >
                                <Icon name="info-rounded" size="24px" color="lightGray" leftIndent="8px" />
                            </Row>
                        </PanelRightBlock>
                    )}
                </PanelRow>
            </Panel>
        </Row>
    );

    const basicLimit = (basicLimit) => {
        return <React.Fragment key={basicLimit.currencyId}>{limit(basicLimit)}</React.Fragment>;
    };

    const extraLimit = () => {
        return (
            <>
                <Text size="subheader" color="secondary" indent="adaptive-24-32" variant="div">
                    {props.profileExtraTitle}
                </Text>
                {profileForm.extraLimit.map((extraLimit) => basicLimit(extraLimit))}
            </>
        );
    };

    if (props.doNotShowListOfLimits) {
        return <Spinner forceShow={true} />;
    } else if (!profileForm) {
        return false;
    } else {
        const isNotEmptyArray = Array.isArray(profileForm.extraLimit) && profileForm.extraLimit.length > 0;
        return (
            <>
                <CommonPage backUrl={AUTH_PROFILE}>
                    <HeaderPanel title={props.headerTitle} />
                    <Row indent="adaptive-32-48">{profileForm.basicLimit && basicLimit(profileForm.basicLimit)}</Row>
                    {isNotEmptyArray && extraLimit()}
                </CommonPage>
                <PopupNew ref={popupRef} />
            </>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        profileForm: state.extra?.profile_form,
        headerTitle: state.messages.pageMessages.headerTitle,
        pageMessages: state.messages.pageMessages,
        profileBasicAmlDetails: state.messages.pageMessages.profileBasicAmlDetails,
        profileCloseTitle: state.messages.pageMessages.profileCloseTitle,
        profileAmlCurrency: state.messages.pageMessages.profileAmlCurrency,
        profileExtraTitle: state.messages.pageMessages.profileExtraTitle,
        doNotShowListOfLimits: state.extra?.doNotShowListOfLimits,
    };
};
export default connect(mapStateToProps)(BasePage(ProfileLimitsPage));
